// extracted by mini-css-extract-plugin
export var chip = "_bk-0";
export var filterDropdown = "_bk-5";
export var filterItem = "_bk-6";
export var icon = "_bk-1";
export var removeButton = "_bk-3";
export var removeIcon = "_bk-4";
export var separator = "_bk-2";